import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import PrivateRoutes from './routes/PrivateRoutes';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import ErrorPage from './pages/ErrorPage';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import LoginPage from './pages/Login/LoginPage';
import ARDashboard from './pages/Ariba/ARDashboard';
import Reporting from './pages/Ariba/ARReporting/Reporting';
import ForecastCollabCPS from './pages/Ariba/CPS';
import SupplierManagement from './pages/Ariba/SupplierManagement';
import KPIMetricReports from './pages/Ariba/KPIMetrics/KPIMetricReports';
import AlertsPage from './pages/Ariba/Alerts/AlertsPage';
import AdminAnnouncements from './pages/Ariba/AdminAnnouncements/AdminAnnouncements';
import SupplierAnnouncements from './pages/Ariba/SupplierAnnouncements/SupplierAnnouncement';
import VideoPlayer from './pages/videoContent/VideoPlayer';
import AdminTraining from './pages/adminTraining/AdminTraining';
import POExceptionManagement from './pages/POExceptionManagement';
import { ExtractForecastFromSAP } from './pages/Ariba/ExtractForecastSAP/ExtractForecastFromSAP';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

document.title = process.env.REACT_APP_PAGE_TITLE;

const observerError = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener("error", (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
});

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <App />
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ARDashboard />,
          },
        ],
      },
      {
        path: "forecastCollabPage",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ForecastCollabCPS />,
          },
        ],
      },
      {
        path: "poExceptionManagement",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <POExceptionManagement />,
          },
        ],
      },
      {
        path: "reports",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <Reporting />,
          },
        ],
      },
      {
        path: "admin-announcements",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminAnnouncements />,
          },
        ],
      },
      {
        path: "kpimetrics",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <KPIMetricReports />,
          },
        ],
      },
      {
        path: "alerts",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AlertsPage />,
          },
        ],
      },
      {
        path: "admin",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "/admin/manage-users",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "/admin/manage-reason-codes",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierManagement />,
          },
        ],
      },
      {
        path: "supplier-announcements",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <SupplierAnnouncements />,
          },
        ],
      },
      {
        path: "training",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <VideoPlayer />,
          },
        ],
      },
      {
        path: "admin-training",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <AdminTraining />,
          },
        ],
      },
      {
        path: "extract-forecast-from-sap",
        element: <PrivateRoutes />,
        children: [
          {
            path: "",
            element: <ExtractForecastFromSAP />,
          },
        ],
      },
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
    </MsalProvider>
  </React.StrictMode>
);
reportWebVitals();
